import { render, staticRenderFns } from "./BaseReviewState.vue?vue&type=template&id=7ca1ff88"
import script from "./BaseReviewState.vue?vue&type=script&lang=js"
export * from "./BaseReviewState.vue?vue&type=script&lang=js"
import style0 from "./BaseReviewState.vue?vue&type=style&index=0&id=7ca1ff88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports